import { render, staticRenderFns } from "./SectionMainContacts.vue?vue&type=template&id=38a596c9&scoped=true&"
import script from "./SectionMainContacts.vue?vue&type=script&lang=js&"
export * from "./SectionMainContacts.vue?vue&type=script&lang=js&"
import style0 from "./SectionMainContacts.vue?vue&type=style&index=0&id=38a596c9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a596c9",
  null
  
)

export default component.exports